import React, { useState } from 'react'
import { ChakraProvider } from '@chakra-ui/react'
import {
  MsalProvider,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react'
import { PublicClientApplication } from '@azure/msal-browser'
import Login from './Login'
import Home from './pages/home'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import './App.css'

export const Tlas = () => {
  const [msalConfig, setMsalConfig] = useState({
    auth: {
      clientId: '',
      authority: 'https://login.microsoftonline.com/organizations',
      redirectUri: '',
    },
    cache: {
      cacheLocation: 'sessionStorage', // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if y ou are having issues on IE11 or Edge
    },
  })

  const msalInstance = new PublicClientApplication(msalConfig)

  return (
    <MsalProvider instance={msalInstance}>
      <AuthenticatedTemplate>
        <ChakraProvider>
          <Home />
        </ChakraProvider>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <ChakraProvider>
          <Login setMsalConfig={setMsalConfig} msalConfig={msalConfig} />
        </ChakraProvider>
      </UnauthenticatedTemplate>
    </MsalProvider>
  )
}
